const initialState = {
  income: null,
	single: null,
	credit: null,
	person: null,
	photo: null,
  incomeWant: null,
	singleWant: null,
	creditWant: null,
	personWant: null,
	photoWant: null,
  datetime: null,
};

export default function reducer(state = initialState, action) {

	if (action.type === 'MY_PROOF_SET') {
		let newState = Object.assign({}, state);
		newState.person = action.payload.person;
    newState.photo = action.payload.photo;
    newState.single = action.payload.single;
    newState.income = action.payload.income;
    newState.credit = action.payload.credit;
    newState.personWant = action.payload.personWant;
    newState.photoWant = action.payload.photoWant;
    newState.singleWant = action.payload.singleWant;
    newState.incomeWant = action.payload.incomeWant;
    newState.creditWant = action.payload.creditWant;
    newState.datetime = (new Date());
		return newState;
	}
	else {
		return state;
	}
}
